import { useMemo } from 'react';

import useGetLoanSummary from '~/common/hooks/useGetLoanSummary';

/**
 * Returns isVAIRRRL (boolean) for VA IRRRL loans.
 * Usage: const isVAIRRRL = useVAIRRRLCheck();
 */
export function useVAIRRRLCheck() {
  const { data: loanSummary } = useGetLoanSummary();

  return useMemo(() => {
    const loanInfo = loanSummary?.loanInfo;
    const propertyData = loanSummary?.propertyData;
    const productType = loanInfo?.loanProductType;
    const refiPurpose = propertyData?.refiPurpose;
    return productType === 'VA' && refiPurpose === 'VA Interest Rate Reduction';
  }, [loanSummary]);
}
